import React, { useState } from 'react'
import { AppBar, Tabs, Tab } from '@material-ui/core'

function MultiTabBlock({ multiTabContent, columns, step }) {
    const [tab, setTab] = useState(0)

    const handleChangeTabs = (_, newValue) => {
        setTab(newValue)
    }

    return (
        <>
            <AppBar position="static" color="default" key="appbar">
                <Tabs
                    value={tab}
                    onChange={handleChangeTabs}
                    variant="scrollable"
                    scrollButtons="auto"
                    key="tabs"
                >
                    {columns.map((colName, index) => (
                        <Tab
                            key={index}
                            label={colName}
                            style={{ color: `${colName?.toLowerCase() === step?.toLowerCase() ? 'green' : 'inherit'}` }}
                        />
                    ))}
                </Tabs>
            </AppBar>
            {columns.map((colName, index) =>
                tab === index && (
                    <div key={`tabContainer-${index}`} style={{ marginTop: '1rem', padding: '1rem' }}>
                        {multiTabContent(colName)}
                    </div>
                )
            )}
        </>
    )
}

export default MultiTabBlock